import * as React from 'react';
import b from 'b_';
import { GeoProp } from '../../types';

interface Props {
  className?: string;
  geo: GeoProp;
}

export default class Plot extends React.Component<Props> {
  render() {
    const {
      className,
      children,
      geo: { left, top, width, height },
    } = this.props;
    return (
      <g
        className={b(className || 'chart', 'plot')}
        transform={`translate(${(left || 0) + 0.5}, ${(top || 0) + 0.5})`} // + 0.5 for thinner lines
        width={width}
        height={height}
      >
        {children}
      </g>
    );
  }
}
